// interface calculateRangeOfDaysProps {}
const calculateRangeOfDays = (startDate: string, endDate: string): number => {
  const oneDay = 24 * 60 * 60 * 1000 // hours*minutes*seconds*milliseconds

  const firstDate = new Date(
    Number(startDate.substr(0, 4)),
    Number(startDate.substr(5, 2)),
    Number(startDate.substr(8, 2))
  ).getTime()

  const secondDate = new Date(
    Number(endDate.substr(0, 4)),
    Number(endDate.substr(5, 2)),
    Number(endDate.substr(8, 2))
  ).getTime()

  const diffDays = (secondDate - firstDate) / oneDay

  return diffDays
}
export default calculateRangeOfDays
